var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenCopy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.75 3.273H5.1c-.939 0-1.7.727-1.7 1.623v11.48c0 .897.761 1.624 1.7 1.624h7.65c.939 0 1.7-.727 1.7-1.623V4.897c0-.897-.761-1.624-1.7-1.624zM5.684 4.896h6.5c.312 0 .566.242.566.541v10.399a.554.554 0 0 1-.567.54h-6.5a.554.554 0 0 1-.566-.54V5.437c0-.299.254-.54.567-.54zM1.636 0h7.746a.818.818 0 1 1 0 1.636H1.7v10.605a.85.85 0 0 1-1.7 0V1.636C0 .733.733 0 1.636 0zM1.7 1.636h.837a.837.837 0 0 0-.837.837v-.837z",
    id: "7qb28alc6a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.7 1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "0sl2fo29hb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#7qb28alc6a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFDB00",
    fillRule: "nonzero",
    xlinkHref: "#7qb28alc6a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#0sl2fo29hb)",
    fill: "#40AE29"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.4,
    height: 36,
    rx: 5,
    transform: "translate(-11.9 -9)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCopy);
export default __webpack_public_path__ + "static/media/green_copy.bdf1501651f448a8a260cef21c499c2d.svg";
export { ForwardRef as ReactComponent };